import Sidebar, { NavLink } from '.';

const SidebarWrapper = () => {
  const navLinks: NavLink[] = [
    { label: 'QA', link: '/qa', icon: 'document-detail' },
    { label: 'Enheter', link: '/enheter', icon: 'store' },
    { label: 'Kjeder', link: '/kjeder', icon: 'kradmin' },
    { label: 'Enhetsgrupperinger', link: '/enhetsgruppering', icon: 'cooperation' },
    { label: 'Bransjer', link: '/bransjer', icon: 'category' },
    { label: 'Grossister', link: '/grossister', icon: 'wholesaler' },
    { label: 'Mottakere', link: '/mottakere', icon: 'users' },
    { label: 'Abonnement', link: '/abonnement', icon: 'credit-card' },
    { label: 'Distribusjoner', link: '/distribusjoner', icon: 'takecargo' },
    { label: 'Importer', link: '/importer', icon: 'import' },
    {
      label: 'Alkoholbevillinger',
      link: '/importer/alkoholbevillinger',
      icon: 'import',
    },
    { label: 'Bulkjobber', link: '/bulkjobber', icon: 'combine' },
    {
      label: 'Brreg synk',
      link: '/brreg-oppdateringer',
      icon: 'more-layers',
      subLinks: [
        { label: 'Brreg oppdateringer', link: '/brreg-oppdateringer', icon: 'more-layers' },
        { label: 'Nye underenheter', link: '/nye-underenheter', icon: 'store' },
        { label: 'Nace endringer', link: '/nace-endringer', icon: 'more-layers' },
        { label: 'Nace kode import', link: '/nace-kode-import', icon: 'import' },
      ],
    },
    {
      label: 'Innkjøp og grossister',
      link: '/innkjop-grossister',
      icon: 'takecargo',
    },
    {
      label: 'Dagligvare omsetning',
      link: '/dagligvare-omsetning',
      icon: 'import',
    },
    {
      label: 'INNK synkronisering',
      link: '/innkjop-sync',
      icon: 'cooperation',
    },
    {
      label: 'Kjeder til nedleggelse',
      link: '/kjeder-til-nedleggelse',
      icon: 'more-layers',
    },
    {
      label: 'Databerikelse',
      link: '/enrichment-dashboard',
      icon: 'more-layers',
    },
    { label: 'Dokumentasjon', link: '/docs', icon: 'info' },
  ];
  return <Sidebar navLinks={navLinks} />;
};

export default SidebarWrapper;
